export default __webpack_public_path__ + "static/media/Project2_TechnicalSummary.0e592ac1.pdf";